import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth-guard/auth.guard';
import { OnboardingComponent } from './view/onboarding-container/onboarding/onboarding.component';
import { OnboardingHomeComponent } from './view/onboarding-container/onboarding-home/onboarding-home.component';
import { NewBusinessComponent } from './view/onboarding-container/new-business/new-business.component';
import { TermsComponent } from './view/onboarding-container/terms/terms.component';
import { PrivacyComponent } from './view/onboarding-container/privacy/privacy.component';
import { MailOnboardingComponent } from './view/onboarding-container/mail-onboarding/mail-onboarding.component';
import { StylistOnboardingComponent } from './view/onboarding-container/stylist-onboarding/stylist-onboarding.component';
import { ClientOnboardComponent } from './view/onboarding-container/client-onboard/client-onboard.component';
import { FreeOnboardComponent } from './view/onboarding-container/free-onboard/free-onboard.component';
import { PaymentComponent } from './view/onboarding-container/payment/payment.component';

const routes: Routes = [
  {
    path: "",
    redirectTo: "/on-boarding",
    pathMatch: 'full'
  },
  {
    path: "onboarding",
    component: OnboardingComponent
  },
  {
    path: "home",
    component: OnboardingHomeComponent
  },
  {
    path: "newbusiness",
    component: NewBusinessComponent
  },
  {
    path: "terms",
    component: TermsComponent
  },
  {
    path: "privacy",
    component: PrivacyComponent
  },
  {
    path: "on-boarding",
    component: MailOnboardingComponent
  },
  {
    path: "service-provider-onboarding",
    component: StylistOnboardingComponent
  },
  {
    path: "client-onboarding",
    component: ClientOnboardComponent
  },
  {
    path: "free-onboarding",
    component: FreeOnboardComponent
  },
  {
    path: "payment",
    component: PaymentComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
